/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseDto';
import type { Wealthlane_AwardService_Dtos_Response_ExerciseTransactionResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ExerciseTransactionResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ImportOptionExerciseSharedService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ExerciseTransactionResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppImportOptionExerciseOptionExerciseRequest(
requestBody?: Array<Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ExerciseTransactionResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/import-option-exercise/option-exercise-request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
